import { clamp } from "modules/clamp";
import toCDNUrl from "./toCDNUrl";

const IMAGE_SIZE = 80;
const CONCURRENT_IMAGE_LIMIT = 10;

export class RoomLogHtmlImageCache {
  private dataUrls = new Map<string, string | null>();

  public async getDataUrls(urls: string[]) {
    for (let i = 0; i < urls.length; i += CONCURRENT_IMAGE_LIMIT) {
      const targetUrls = urls.slice(i, i + CONCURRENT_IMAGE_LIMIT);
      await Promise.all(
        targetUrls.map(async (url) => {
          if (!this.dataUrls.has(url)) {
            this.dataUrls.set(url, await this.createDataUrl(url));
          }
        })
      );
    }

    return new Map(
      urls.map((url) => [url, this.dataUrls.get(url) || null] as const)
    );
  }

  private async createDataUrl(url: string) {
    if (!url) return null;
    const cdnUrl = toCDNUrl(url);
    let imageBitmap: ImageBitmap | null = null;
    try {
      const response = await fetch(cdnUrl);
      if (!response.ok) return null;
      const blob = await response.blob();
      imageBitmap = await createImageBitmap(blob);
      const sourceSize = Math.min(imageBitmap.width, imageBitmap.height);
      const sourceX = (imageBitmap.width - sourceSize) / 2;
      const outputSize = clamp(sourceSize, { min: 1, max: IMAGE_SIZE });
      const canvas = document.createElement("canvas");
      canvas.width = outputSize;
      canvas.height = outputSize;

      const context = canvas.getContext("2d");
      if (!context) return null;
      context.drawImage(
        imageBitmap,
        sourceX,
        0,
        sourceSize,
        sourceSize,
        0,
        0,
        outputSize,
        outputSize
      );
      return canvas.toDataURL(blob.type);
    } catch {
      return null;
    } finally {
      imageBitmap?.close();
    }
  }
}
